module.exports = __webpack_public_path__ + "static/media/2022-may-image-2.8e1cf3cb.png";